import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Route } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import SideMenuNavList from '../Dashboard/SideMenuNavList';
import FooterContainer from '../../components/Footers/FooterContainer';
import HeaderContainer from '../../components/Headers/HeaderContainer';

import AdminLawyer from '../../pages/AdminLawyer';
import AdminLawyerFirm from '../../pages/AdminLawyerFirm';
import AdminClient from '../../pages/AdminClient';
import AdminContactCenter from '../../pages/AdminContactCenter';

import * as ROUTES from '../../routes';

const mobileHeightTopAppBar = 56;
const desktopHeightTopAppBar = 64;

const styles = () => ({
  root: {
    display: 'flex',
  },
  content: {
    paddingTop: isMobile
      ? mobileHeightTopAppBar + 24
      : desktopHeightTopAppBar + 24,
    flexGrow: 1,
    // height: 'auto',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#f6f8fb',
  },
});

export const DashBoardAdmin = ({ classes }) => {
  const [expandSideMenu, setExpandSideMenu] = useState(true);
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadingFormData, setLoadingFormData] = useState(true);

  const tabletSize = useMediaQuery('(max-width: 768px)');

  const handleOpenMenu = (name) => (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = (name) => (event) => {
    event && event.preventDefault();
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setOpenSideMenu(true);
  };

  const handleDrawerClose = () => {
    setOpenSideMenu(false);
  };

  const toggleSideMenu = () => {
    setExpandSideMenu(!expandSideMenu);
  };

  const toggleDrawer = (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    /* setState(prevState => ({ openSideMenu: !prevState.openSideMenu })); */
    setOpenSideMenu(!openSideMenu);
  };

  return (
    <>
      <div>
        <HeaderContainer
          isExpandedSideMenu={tabletSize ? openSideMenu : expandSideMenu}
          handleOpenSideMenu={tabletSize ? toggleDrawer : toggleSideMenu}
          handleOpenMenu={handleOpenMenu('anchorEl')}
          openDrawer={openSideMenu}
          handleToggleDrawer={toggleDrawer}
        />
        <div style={{ maxWidth: 1920, margin: '0 auto' }}>
          <div style={{ maxWidth: 1360, margin: '0 auto' }}>
            <main className={classes.content}>
              <div
                style={
                  tabletSize
                    ? {
                        padding: 0,
                        display: 'flex',
                        justifyContent: 'flex-start',
                      }
                    : {
                        paddingLeft: 24,
                        display: 'flex',
                        justifyContent: 'flex-start',
                      }
                }
              >
                {!tabletSize && (
                  <div className="dashboard-sideMenu">
                    <SideMenuNavList
                      adminMenu
                      expandDrawer={expandSideMenu}
                      isExpandedSideMenu={
                        tabletSize ? openSideMenu : expandSideMenu
                      }
                      handleOpenSideMenu={
                        tabletSize ? toggleDrawer : toggleSideMenu
                      }
                      //handleOpenMenu={handleOpenMenu('anchorEl')}
                      // variant="permanent"
                    />
                  </div>
                )}
                <div
                  style={{
                    width: tabletSize
                      ? '100%'
                      : expandSideMenu
                      ? 'calc(100% - 191px)'
                      : 'calc(100% - 57px)',
                    display: 'flex',
                    padding: tabletSize ? 0 : '0 16px',
                  }}
                >
                  <Route
                    exact
                    path={ROUTES.ADMIN_LAWYER}
                    render={props => <AdminLawyer {...props} />}
                  />
                  <Route
                    exact
                    path={ROUTES.ADMIN_LAWYER_FIRM}
                    render={props => <AdminLawyerFirm {...props} />}
                  />
                  <Route
                    exact
                    path={ROUTES.ADMIN_CLIENT}
                    render={props => <AdminClient {...props} />}
                  />
                  <Route
                    exact
                    path={ROUTES.ADMIN_CONTACT_CENTER}
                    render={props => <AdminContactCenter {...props} />}
                  />
                </div>
              </div>
            </main>
          </div>
        </div>
        <FooterContainer />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(null, null)(withStyles(styles)(DashBoardAdmin));
